import { useSyndeticsConfig } from "@tlc/ls2pac/components/SyndeticsConfig";
import React, { useEffect, useState } from "react";
import { ResourceDWR } from "../../../../dto/ResourceDWR";
import { Box } from "@mui/material";
import {
  getISBNList,
  getUPCList,
} from "@tlc/ls2pac/app/utils/PACStandardNumberUtil";
import {
  LibraryThingEnrichment,
  LibraryThingMetaData,
} from "@tlc/syndetics-util";
import { EnrichmentSection } from "./SyndeticsMoreInfoContent";
import { SyndeticsTermsLink } from "./SyndeticsTermsLink";
import { useLanguage } from "@tlc/ls2pac/components/Language";

export const UnboundClasses: Record<LibraryThingEnrichment, string> = {
  [LibraryThingEnrichment.Summary]: "unbound_summary",
  [LibraryThingEnrichment.VideoAndMusicSummary]: "unbound_audiovideo",
  [LibraryThingEnrichment.VideoGameSummary]: "unbound_game",
  [LibraryThingEnrichment.AboutTheAuthor]: "unbound_author",
  [LibraryThingEnrichment.LookInside]: "unbound_lookinside",
  [LibraryThingEnrichment.Series]: "unbound_series",
  [LibraryThingEnrichment.YouMayAlsoLike]: "unbound_similar",
  [LibraryThingEnrichment.ProfessionalReviews]: "unbound_reviews",
  [LibraryThingEnrichment.AlsoAvailableAs]: "unbound_other",
  [LibraryThingEnrichment.Tags]: "unbound_tags",
  [LibraryThingEnrichment.BookProfile]: "unbound_bookprofile",
  [LibraryThingEnrichment.Awards]: "unbound_awards",
  [LibraryThingEnrichment.RCLCoreTitles]: "unbound_rcl",
  [LibraryThingEnrichment.AltmetricBadges]: "unbound_altmetrics",
  [LibraryThingEnrichment.AlternateSeries]: "unbound_ltseries",
  [LibraryThingEnrichment.MainCover]: "", // unused
  [LibraryThingEnrichment.Lists]: "unbound_lists",
};

export interface SyndeticsRelatedContentProps {
  resource: ResourceDWR;
}
export const SyndeticsRelatedContent = ({
  resource,
}: SyndeticsRelatedContentProps) => {
  const {
    hasRelatedTabEnrichments,
    enrichmentsEnabled,
    relatedTabEnrichments,
    util,
    syndeticsConfig,
  } = useSyndeticsConfig();
  const { translate } = useLanguage();
  const id = `resource_${resource?.id}_related`;
  const [enrichmentsShown, setEnrichmentsShown] =
    useState<LibraryThingEnrichment[]>(undefined);
  const [noContent, setNoContent] = useState<boolean>();

  useEffect(() => {
    const refreshMetaData = async () => {
      var isbn = getISBNList(resource.standardNumbers);
      var upc = getUPCList(resource.standardNumbers);
      const metaData: LibraryThingMetaData = {
        unbound_containing_selector: `#${id}`,
        title: resource.shortTitle,
        author: resource.shortAuthor,
        isbn: isbn,
        upc: upc,
        usemegadiv: false,
        branchFilters: syndeticsConfig.branchFilters,
      };
      try {
        const { errors, enrichmentsShown } = await util.refreshMetaData(
          metaData
        );
        setEnrichmentsShown(enrichmentsShown);
        const anyLoaded = relatedTabEnrichments.some((enrichment) =>
          enrichmentsShown.includes(enrichment)
        );
        setNoContent(!anyLoaded);
        console.log("Responded", enrichmentsShown, errors);
      } catch (e: unknown) {
        console.error(e);
        setNoContent(true);
      }
    };
    if (
      util &&
      syndeticsConfig?.active &&
      hasRelatedTabEnrichments &&
      resource?.id
    ) {
      refreshMetaData();
    }
  }, [util, syndeticsConfig?.active, hasRelatedTabEnrichments, resource?.id]);

  if (!hasRelatedTabEnrichments) {
    return null;
  }

  return (
    <Box id={id}>
      {relatedTabEnrichments.map((enrichment) => {
        if (enrichmentsEnabled.includes(enrichment)) {
          return (
            <EnrichmentSection
              key={enrichment}
              enrichment={enrichment}
              enrichmentsShown={enrichmentsShown}
            />
          );
        } else {
          return null;
        }
      })}
      {noContent && <p>{translate("noContent")}</p>}
      <SyndeticsTermsLink />
    </Box>
  );
};
